import axios from 'axios';
import { tokenVencido } from './helper';
const urlAPi = process.env.REACT_APP_URL_API;

export async function postLogin(data) {
  try {
    const response = await axios.post(
      urlAPi + '/usuario/ingreso',
      {
        mail: data.mail,
        clave: data.clave
      },
      { authRequired: false }
    );
    return response;
  } catch (error) {
    tokenVencido(error?.response?.status);
    throw new Error('');
  }
}

export async function putCambioContrasena(claveActual, claveNueva) {
  try {
    const response = await axios.patch(
      urlAPi + '/Usuario/CambiarClave',
      {
        claveActual: claveActual,
        claveNueva: claveNueva,
        claveNuevaConfirmacion: claveNueva
      },
      { authRequired: true }
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

export async function getUsuarios(idUsuario, rol) {
  try {
    // Construye los parámetros dinámicamente
    const params = {};
    if (idUsuario) params.idUsuario = idUsuario;
    if (rol) params.rol = rol;

    const response = await axios.get(
      urlAPi + '/taller/usuarios',
      {
        params,
        authRequired: true
      }
    );
    return response.data.datos;
  } catch (error) {
    tokenVencido(error?.response?.status);
    throw new Error('');
  }
}

export async function getPermisos() {
  try {
    const response = await axios.get(
      urlAPi + '/taller/permisos',
      { authRequired: true }
    );
    return response.data.datos;
  } catch (error) {
    tokenVencido(error?.response?.status);
    throw new Error('');
  }
}

export async function postPermisoUsuario(data) {
  try {
    const response = await axios.post(
      urlAPi + '/usuario/permiso',
      {
        idPermiso: data.idPermiso,
        idUsuario: data.idUsuario
      },
      { authRequired: true }
    );
    return response;
  } catch (error) {
    tokenVencido(error?.response?.status);
    throw new Error('');
  }
}